import script from "./Loading.vue?vue&type=script&setup=true&lang=js"
export * from "./Loading.vue?vue&type=script&setup=true&lang=js"

import "./Loading.vue?vue&type=style&index=0&id=00975af0&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00975af0"]])

export default __exports__